export default "__VITE_ASSET__BEZhUuJC__"